import { decamelizeKeys } from 'humps';

export function sendBrazeLog(
  eventName: string,
  log: { [key: string]: any },
): void {
  if ((window as any).braze?.logCustomEvent != null) {
    (window as any).braze = (window as any).braze || {};
    (window as any).braze.logCustomEvent(eventName, decamelizeKeys(log));
  }
}
